import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash-es';
import { connect } from 'react-redux';

import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { UserProfileModel } from 'client/data/models/profile/profile';
import { VisitorEntities, VisitorModel } from 'client/data/models/visitor';
import { VinCardsList } from 'site-modules/profile/components/dashboard/vin-cards-list/vin-cards-list';

const INVENTORY_PER_PAGE = 9;

function VinCardsContainerComponent({
  inventory = null,
  userVins,
  vinsWithLeads,
  deleteVinFromIdm,
  updatePriceDropAlerts,
  seeMoreClick,
  visibleSeeMoreButton,
  savedDeals = [],
  compareSelect = null,
  visitorLocation = null,
  isMobile = false,
  currentPage,
}) {
  const [totalInventoryCount] = useState(userVins.length);

  return (
    <VinCardsList
      inventory={inventory}
      inventoryCount={Math.min(totalInventoryCount, currentPage * INVENTORY_PER_PAGE)}
      deleteVinFromIdm={deleteVinFromIdm}
      updatePriceDropAlerts={updatePriceDropAlerts}
      vinsWithLeads={vinsWithLeads}
      seeMoreClick={seeMoreClick}
      visibleSeeMoreButton={visibleSeeMoreButton}
      savedDeals={savedDeals}
      compareSelect={compareSelect}
      visitorLocation={visitorLocation}
      isMobile={isMobile}
    />
  );
}

VinCardsContainerComponent.propTypes = {
  inventory: PropTypes.arrayOf(PropTypes.shape({})),
  userVins: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vinsWithLeads: PropTypes.shape({}).isRequired,
  deleteVinFromIdm: PropTypes.func.isRequired,
  updatePriceDropAlerts: PropTypes.func.isRequired,
  seeMoreClick: PropTypes.func.isRequired,
  visibleSeeMoreButton: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  savedDeals: PropTypes.arrayOf(PropTypes.shape({})),
  compareSelect: PropTypes.shape({}),
  visitorLocation: VisitorEntities.Location,
  isMobile: PropTypes.bool,
};

export const propsAreEqual = (
  { inventory: prevInventory, compareSelect: prevCompareSelect },
  { inventory: nextInventory, compareSelect: nextCompareSelect }
) => {
  const inventoryLengthChanged = nextInventory && prevInventory && prevInventory.length !== nextInventory.length;
  const compareSelectedCarsChanged =
    nextCompareSelect && prevCompareSelect && !isEqual(prevCompareSelect.selectedCars, nextCompareSelect.selectedCars);

  return !(inventoryLengthChanged || !isEqual(prevInventory, nextInventory) || compareSelectedCarsChanged);
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const VinCardsContainer = connect(mapStateToProps)(
  connectToModel(React.memo(VinCardsContainerComponent, propsAreEqual), {
    inventory: bindToPath(
      ({ currentPage }) => `data.savedVINs.itemsPerPage.${INVENTORY_PER_PAGE}.pageNum.${currentPage}`,
      UserProfileModel
    ),
    visitorLocation: bindToPath('location', VisitorModel),
  })
);
